<template>
  <div id="app">
    <splash-screen
      :loading="splashScreen.loading"
      :tabEnabled="splashScreen.tabEnabled"></splash-screen>
    <cursor-spinner
      :processing="cursorSpinner.processing"></cursor-spinner>
    <nav-bar></nav-bar>
    <div class="ui container">
      <report-logo></report-logo>
      <div class="ui segment">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import NavBar from '@/components/NavBar';
import SplashScreen from '@/components/widgets/SplashScreen';
import CursorSpinner from '@/components/widgets/CursorSpinner';
import ReportLogo from '@/components/widgets/ReportLogo';
import DataStore from '@/modules/DataStore';
import ReportSettings from '@/modules/ReportSettings';
import AnalyticsManager from "@/modules/analyticsLibrary/AnalyticsManager";

export default {
  name: 'app',
  components: { NavBar, SplashScreen, CursorSpinner, ReportLogo },
  data: function() {
    return {
      splashScreen: {loading: true, tabEnabled: true},
      cursorSpinner: {processing: false},
      //setVisibility: {}
    }
  },
  beforeCreate () {
    DataStore.init(this.$route.params.report_name);
    ReportSettings.init(DataStore);

    Vue.prototype.$dataStore = DataStore;
    Vue.prototype.$reportSettings = ReportSettings;

    let analyticsManager = new AnalyticsManager();
    analyticsManager.initLoggers();

    Vue.prototype.$_am = analyticsManager;

    Vue.prototype.$cursorSpinner = this.cursorSpinner || {};
    Vue.prototype.$splashScreen = this.splashScreen || {};
  },
  mounted () {
    this.$dataStore.setSplashScreenControl(this.splashScreen);

    Vue.prototype.$splashScreen = this.splashScreen;
    Vue.prototype.$cursorSpinner = this.cursorSpinner;

    Chart.defaults.global.plugins.datalabels = {
      display: this.$chartSettings["chartjs"]["datalabels"]["display"]
    };
  },
  methods: {
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body{
  padding-top: 130px;
}

.navbar.center .navbar-inner {
  text-align: center;
}

.navbar.center .navbar-inner .nav {
  float: none;
  display:inline-block;
  vertical-align: middle;
}

a img.logo {
  width: 2.5em;
  margin: 7px;
}

nav.navbar{
  background-color: #1B1C21;
}

.navbar-nav .active.item {
  background: rgba(255,255,255,.15);
  color: #fff!important;
}

.navbar-default .navbar-nav>li>a:focus, .navbar-default .navbar-nav>li>a:hover {
  background: rgba(255,255,255,.08);
  color: #fff;
}

.navbar-nav .item {
  background: 0 0;
  color: #fff!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue